export default class PushEvents {
  static SCHEMA = {
    RELOADED: "TenantSchemaReloaded",
  };

  static WORKSPACE = {
    RELOADED: "WorkspaceReloaded",
  };

  static CRM_RECORD = {
    OPEN_MODIFY: "OpenCrmRecordModify",
    UPDATED: "CrmRecordUpdated",
    UPDATED_MANY: "CrmRecordsUpdated",
  };

  static TEMPLATE = {
    RELOADED: "TemplateSchemaReloaded",
  };

  static TOAST = {
    NEW: "ShowNewToast",
  };

  static DOCUMENT = {
    CREATED: "newDocumentCreated",
  };

  static WIDGETS = {
    VARIABLES_UPDATED: "WidgetVariablesUpdated",
    REFRESH: "WidgetRefresh",
  };

  static PAGE = {
    REORDER_VIEWS: "pageReorderViews",
  };
}
